import { type AttachmentView, formatFileSize } from "../lib/attachments";
import { FileIcon } from "./icons";

/** Renders a user message's attachments: image thumbnails + non-image file chips. */
export function MessageAttachments({ views }: { views: AttachmentView[] }) {
  if (views.length === 0) return null;
  const images = views.filter((v) => v.isImage && v.src);
  const files = views.filter((v) => !v.isImage || !v.src);

  return (
    <div className="mb-3 flex flex-wrap gap-2">
      {images.map((v) => (
        <img
          key={v.key}
          src={v.src}
          alt={v.fileName}
          className="max-h-56 max-w-[min(100%,320px)] rounded-xl object-cover"
        />
      ))}
      {files.map((v) => (
        <div
          key={v.key}
          className="flex items-center gap-2.5 rounded-lg bg-bubble px-3 py-2 text-ink [&_svg]:size-4 [&_svg]:text-ink-faint"
        >
          <FileIcon />
          <span className="min-w-0">
            <span className="block max-w-[220px] truncate font-sans text-[13px] font-medium">
              {v.fileName}
            </span>
            {v.sizeBytes > 0 ? (
              <span className="block font-sans text-[11px] text-ink-faint">
                {formatFileSize(v.sizeBytes)}
              </span>
            ) : null}
          </span>
        </div>
      ))}
    </div>
  );
}
